export const TIMELINE_ITEMS = {
  // E2R1 Baseline Reactivation
  // BASELINED: 'Baseline',
  PLANNED: 'Current plan',
  ACTUAL_AND_FORECAST: 'Actual / forecast',
};

export const TIMELINE_TYPE = {
  SIMPLE: 'simple',
  COMPLEX: 'complex',
};

export const TEMP = null;
